import { fetchNotifications } from "redux/actions/notifications";
import NotificationRes from "types/res/notification/NotificationRes";
import { createSlice } from "@reduxjs/toolkit";
import CastNotificationRes from "types/res/notification/CastNotificationRes";

export type NotificationState = CastNotificationRes;

const initialState = {} as NotificationState;

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.fulfilled, (_, { payload }) => payload);
  },
});

export default notificationsSlice.reducer;
